import type { Outcome } from "@landing/types"
import { motion } from "framer-motion"
import { memo } from "react"
import { isOutcomeEliminated } from "../utils/outcome-utils"

interface OutcomeTradeIndicatorsProps {
  outcome: Outcome
  heldOutcomes: string[]
  recentTrades: Record<string, { type: "buy" | "sell"; timestamp: number }>
  isFinal: boolean
  state: "live" | "upcoming" | "final"
}

export const OutcomeTradeIndicators = memo(function OutcomeTradeIndicators({
  outcome,
  heldOutcomes,
  recentTrades,
  isFinal,
  state,
}: OutcomeTradeIndicatorsProps) {
  if (isFinal || state === "upcoming") return null

  const isEliminated = isOutcomeEliminated(outcome, heldOutcomes)
  const tradeType = recentTrades[outcome.name]?.type

  return (
    <div className="flex flex-col mr-2.5 ml-1 space-y-[2px]">
      <motion.span
        animate={{
          color: isEliminated
            ? "rgba(255, 255, 255, 0.08)"
            : tradeType === "buy"
              ? "#22FF65"
              : "rgba(255, 255, 255, 0.08)",
        }}
        transition={{ duration: 0.05 }}
        className="text-[42%] leading-none"
      >
        ▲
      </motion.span>
      <motion.span
        animate={{
          color: isEliminated
            ? "rgba(255, 255, 255, 0.08)"
            : tradeType === "sell"
              ? "#FF0000"
              : "rgba(255, 255, 255, 0.08)",
        }}
        transition={{ duration: 0.02 }}
        className="text-[42%] leading-none"
      >
        ▼
      </motion.span>
    </div>
  )
})
